import { render, staticRenderFns } from "./DepartmentProfileDataView.vue?vue&type=template&id=42ed2104&scoped=true&"
import script from "./DepartmentProfileDataView.vue?vue&type=script&lang=js&"
export * from "./DepartmentProfileDataView.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentProfileDataView.vue?vue&type=style&index=0&id=42ed2104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed2104",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCardText,VFlex,VIcon,VLayout,VSpacer,VSubheader,VTextField,VToolbar,VToolbarTitle})
